import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ModalController } from "ionic-angular";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-icon",
  templateUrl: "icon.html",
})

export class IconComponent {

  @Input() public form: FormControl;

  constructor(
    private modalCtrl: ModalController,
    private utilities: Utilities,
  ) { }

  public openModal() {
    const modal = this.modalCtrl.create("IconSelectorPage");
    modal.present();
    modal.onDidDismiss((data) => {
      if (data) {
        this.utilities.consoleDecorator("Icon", data);
        this.form.patchValue(data.icon);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/icon/icon.ts